export default {"src":"/_next/static/media/HAS.449adcc1.svg","height":18,"width":18};